import { API_HOST } from "constants/config";
import { ESTATE_MY_ORDER_LIST_URL, ESTATE_MY_OVERDUE_LIST_URL, ESTATE_ROOM_OVERDUE_DETAIL_URL, } from "constants/urls";
import http from "network/http";
import { useEffect, useRef, useState } from "react"
import { Link, useNavigate } from "react-router-dom";
import { Card, Cell, Dialog, List, ListInstance, NavBar, PullRefresh, Toast } from "react-vant";
import { AppState } from "state";
import { useAppSelector } from "state/hooks";
import { Order, Overdue } from "types";



declare type Page = {
  current: number, total: number
}

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
  let navigate = useNavigate();
  const unmountedRef = useRef<boolean>(false);
  const listRef = useRef<ListInstance>(null);
  const [page, setPage] = useState<Page | null>(null);
  const [finished, setFinished] = useState<boolean>(false);
  const [list, setList] = useState<Array<Order>>([]);
  const [loading, setLoading] = useState(false)
  const { jwt } = useAppSelector((state: AppState) => state.user);
  const onLoadRefresh = async (isRefresh?: number) => {
    setLoading(true)

    var pageNumber = 1
    if (!isRefresh && page?.current) {
      pageNumber = page.current + 1
    }

    const res = await http.get(
      `${API_HOST}${ESTATE_MY_ORDER_LIST_URL}?page=${pageNumber}`,{headers:{"Authorization": 'Bearer ' + jwt}}
    )

    const results = res.data.results
    const _page = res.data.page
    setPage(_page)
    setList((v) => {
      const newList = isRefresh ? results : [...v, ...results];
      if (newList.length >= _page.total) {
        setFinished(true);
      }

      return newList;
    });
    setLoading(false)


  };

  const onRefresh = async () => {
    setFinished(false);
    await onLoadRefresh(1);
    listRef.current?.check();
  };

  useEffect(() => {

    return () => {
      unmountedRef.current = true;
    };
  }, []);



  return (
    <>
      <NavBar
        title="缴费记录"
        leftText="返回"
        onClickLeft={() => { navigate("/my") }}
      />
      {

      }
      <PullRefresh onRefresh={onRefresh} >
        <Cell.Group title={""}>
        </Cell.Group>
        <List ref={listRef} finished={finished} loading={loading} onLoad={onLoadRefresh} >
          {
            list?.map((item, i) => {
              return <Card key={i} style={{ margin: 10 }}>
                <Card.Body>
                  <Cell title={"订单"} value={item.id} />
                  <Cell title={"订单创建时间"} value={item.created_at} />
                  <Cell title={"付款金额"} value={item.total_price} />
                  <Cell title={"支付状态"} value={item.payment_status_display} />
         
                </Card.Body>
              </Card>;
            })
          }
        </List>

      </PullRefresh>

    </>
  )
}



